<template>
  <ValidationObserver
      ref="observer"
      class="preservice-record-form transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <ValidationObserver ref="mainForm" class="flex flex-wrap my-6 mx-6 mb-6">
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >First Name</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                required: true,
                regex:
                '^[A-Za-z][A-Za-z ]*$'
                          }">
                <input
                    id="firstName"
                    v-model="formValues.firstName"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Father Name</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                required: true,
                regex:
                '^[A-Za-z][A-Za-z ]*$'
                          }">
                <input
                    id="fatherName"
                    v-model="formValues.fatherName"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Grand Father Name</label
              >
              <validation-provider
                  v-slot="{ errors }"

                  :rules="{
                required: true,
                regex:
                '^[A-Za-z][A-Za-z ]*$'
              }">
                <input
                    id="grandFatherName"
                    v-model="formValues.grandFatherName"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
              >Sex</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <input
                    id="Male"
                    v-model="formValues.sex"
                    class="my-3 ml-5"
                    type="radio"
                    value="Male"
                />
                <label for="Male"> Male </label>

                <input
                    id="Female"
                    v-model="formValues.sex"
                    class="my-3 ml-5"
                    type="radio"
                    value="Female"
                />
                <label for="Female"> Female </label>
                <br/>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
              <br/>
            </div>
            <div class="w-full md:w-1/2 px-3 required">
              <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Date of Birth:
              </label>

              <validation-provider v-slot="{ errors }" rules="required">
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :open-on-click="false"
                    max-width="290px"
                    min-width="290px"
                    offset-y
                    transition="scale-transition"
                >
                  <template v-slot:activator="{ attrs }">
                    <v-text-field
                        v-model="dateOfBirthInput"
                        hint="Use YYYY-MM-DD or DD-MM-YYYY"
                        label="Birth date"
                        prepend-icon="mdi-calendar"
                        persistent-hint
                        placeholder="YYYY-MM-DD"
                        v-bind="attrs"
                        :error-messages="dateOfBirthError ? [dateOfBirthError] : []"
                        @click:prepend="menu = true"
                        @input="onDateOfBirthInput"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      ref="dateOfBirth"
                      v-model="formValues.dateOfBirth"
                      :max="maxBirthDate"
                      no-title
                      scrollable
                      @input="onDateOfBirthPicked"
                  ></v-date-picker>
                </v-menu>

                <span class="text-gray-600 text-xs italic text-red-700">{{
                    dateOfBirthError || errors[0]
                  }}</span>
              </validation-provider>
              <br/>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >National ID (FAN)</label
              >
              <validation-provider v-slot="{ errors }" rules="required|fan_id">
                <input
                    id="idNo"
                    v-model="formValues.idNo"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    inputmode="numeric"
                    maxlength="19"
                    name
                    placeholder="1234 2345 7865 5466"
                    type="text"
                    @blur="loadExistingStudentIdentity"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Program Education Type</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                    v-model="programValue"
                    :elevation="1"
                    :items="EDUCATIONAL_PROGRAMS"
                    :loading="lookupLoading"
                    dense
                    item-text="name"
                    item-value="name"
                    return-object
                    solo
                ></v-autocomplete>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Department / Discipline</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                    v-model="disciplineValue"
                    :elevation="1"
                    :items="DISCIPLINES"
                    :loading="lookupLoading"
                    dense
                    item-text="name"
                    item-value="name"
                    return-object
                    solo
                ></v-autocomplete>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Level Of Study</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                    v-model="formValues.levelOfStudyId"
                    :elevation="1"
                    :items="LEVEL_OF_STUDIES"
                    :loading="lookupLoading"
                    dense
                    item-text="name"
                    item-value="id"
                    solo
                ></v-autocomplete>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Year of Entry</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                  required: true,
                  generic_regex: '^[0-9]{4}$',
                  min_generic_value: 1950,
                  max_generic_value: new Date().getFullYear(),
                }"
              >
                <YearPickerField
                    v-model="entryYearValue"
                    :max-year="currentYear"
                    :min-year="1950"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Expected Graduation Year</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                  required: true,
                  generic_regex: '^[0-9]{4}$',
                }"
              >
                <YearPickerField
                    v-model="proposedYearValue"
                    disabled
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Year Of Graduation</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                  generic_regex: '^[0-9]{4}$',
                  min_proposed_value: proposedYearValue,
                }"
              >
                <YearPickerField
                    v-model="formValues.graduationYear"
                    :disabled="!entryYearValue"
                    :min-year="proposedYearValue"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Nationality</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                required: true,
                regex:
                '^[A-Za-z][A-Za-z ]*$'
                          }">
                <input
                    id="nationality"
                    v-model="formValues.nationality"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Ethnicity</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                    v-model="formValues.ethnicity"
                    :elevation="1"
                    :items="ETHNICITIES"
                    :loading="lookupLoading"
                    dense
                    item-text="name"
                    item-value="name"
                    solo
                ></v-autocomplete>
                <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="w-full">
              <div
                  class="title"
                  style="background-color: #f7fafc; padding: 5px 24px;"
              >
                Birth Place
              </div>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Birth Region</label>
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                    v-model="formValues.birthRegionId"
                    :elevation="1"
                    :items="BIRTH_REGIONS"
                    :loading="birthPlaceLookupLoading"
                    dense
                    item-text="name"
                    item-value="id"
                    solo
                    @change="onBirthRegionChange"
                ></v-autocomplete>
                <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Birth Zone</label>
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                    v-model="formValues.birthZoneId"
                    :disabled="!formValues.birthRegionId"
                    :elevation="1"
                    :items="BIRTH_ZONES"
                    :loading="birthPlaceLookupLoading"
                    dense
                    item-text="name"
                    item-value="id"
                    solo
                    @change="onBirthZoneChange"
                ></v-autocomplete>
                <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Birth Woreda</label>
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                    v-model="formValues.birthWoredaId"
                    :disabled="!formValues.birthZoneId"
                    :elevation="1"
                    :items="BIRTH_WOREDAS"
                    :loading="birthPlaceLookupLoading"
                    dense
                    item-text="name"
                    item-value="id"
                    solo
                ></v-autocomplete>
                <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Town / Village</label>
              <validation-provider v-slot="{ errors }" rules="required">
                <input
                    v-model="formValues.birthTownVillage"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <template>
              <div class="w-full">
                <div
                    class="title"
                    style="background-color: #f3f3f3; padding: 5px 24px;"
                >
                  About Higher Learning Institution
                </div>
              </div>
              <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
                <label
                    class="
                    block
                    uppercase
                    tracking-wide
                    text-gray-700 text-xs
                    font-bold
                    mb-2
                    "
                >University / Educational Institution</label
                >
                <validation-provider v-slot="{ errors }" rules="required">
                  <v-autocomplete
                      v-model="selectedUniversity"
                      :disabled="isUniversityScopedUser"
                      :elevation="1"
                      :items="UNIVERSITIES"
                      :loading="universityLoading"
                      dense
                      item-text="name"
                      return-object
                      solo
                      @change="onUniversityChanged"
                  ></v-autocomplete>
                  <span class="text-gray-600 text-xs italic text-red-700">{{
                      errors[0]
                    }}</span>
                </validation-provider>
              </div>
              <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label
                    class="
                    block
                    uppercase
                    tracking-wide
                    text-gray-700 text-xs
                    font-bold
                    mb-2
                    "
                >University Owner</label
                >
                <v-text-field
                    v-model="formValues.ownership"
                    dense
                    readonly
                    solo
                ></v-text-field>
              </div>
              <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label
                    class="
                    block
                    uppercase
                    tracking-wide
                    text-gray-700 text-xs
                    font-bold
                    mb-2
                    "
                >Region</label
                >
                <v-text-field
                    v-model="formValues.region"
                    dense
                    readonly
                    solo
                ></v-text-field>
              </div>
              <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label
                    class="
                    block
                    uppercase
                    tracking-wide
                    text-gray-700 text-xs
                    font-bold
                    mb-2
                    "
                >Town</label
                >
                <v-text-field
                    v-model="formValues.town"
                    dense
                    readonly
                    solo
                ></v-text-field>
              </div>
            </template>
          </ValidationObserver>
          <div class="w-full">
            <div
                class="preservice-status-section-title title"
            >
              Student Grade Information
            </div>
          </div>
          <ValidationObserver ref="subForm">
            <v-card
                class="preservice-status-entry-card flex flex-wrap my-2 mb-4"
                outlined
            >
              <div class="w-full">
                <v-container class="preservice-status-entry-container">
                  <v-row class="preservice-status-entry-row" dense>
                    <v-col class="preservice-status-field" cols="12" md="3" sm="6">
                      <label
                          class="preservice-status-label"
                      >Year Of Education</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-autocomplete
                            v-model="studentStatusItem.yearOfEducation"
                            :elevation="1"
                            :items="YEAR_OF_EDUCATION"
                            :loading="lookupLoading"
                            class="preservice-status-control"
                            dense
                            hide-details
                            item-text="name"
                            item-value="name"
                            outlined
                        >
                        </v-autocomplete>
                        <span class="preservice-status-error text-gray-600 text-xs italic text-red-700">{{
                            errors[0]
                          }}</span>
                      </validation-provider>
                    </v-col>
                    <v-col class="preservice-status-field" cols="12" md="3" sm="6">
                      <label
                          class="preservice-status-label"
                      >Student Status</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-autocomplete
                            v-model="studentStatusItem.studentStatus"
                            :elevation="1"
                            :items="STUDENT_STATUSES"
                            :loading="lookupLoading"
                            class="preservice-status-control"
                            dense
                            hide-details
                            item-text="name"
                            item-value="name"
                            outlined
                        ></v-autocomplete>
                        <span class="preservice-status-error text-gray-600 text-xs italic text-red-700">{{
                            errors[0]
                          }}</span>
                      </validation-provider>
                    </v-col>
                    <v-col class="preservice-status-field" cols="12" md="2" sm="6">
                      <label
                          class="preservice-status-label"
                      >GPA:
                      </label>
                      <validation-provider
                          v-slot="{ errors }"
                          :rules="{
                        min_gpa: 0,
                        max_gpa: 4,
                        required: true,
                      }"
                      >
                        <v-text-field
                            id="gpa"
                            v-model="studentStatusItem.gpa"
                            class="preservice-status-control"
                            dense
                            hide-details
                            name
                            outlined
                            step="0.01"
                            type="number"
                        ></v-text-field>
                        <span class="preservice-status-error text-gray-600 text-xs italic text-red-700">{{
                            errors[0]
                          }}</span>
                      </validation-provider>
                    </v-col>
                    <v-col class="preservice-status-field" cols="12" md="2" sm="6">
                      <label
                          class="preservice-status-label"
                      >Cumulative GPA:
                      </label>
                      <validation-provider
                          v-slot="{ errors }"
                          :rules="{
                            min_gpa: 0,
                            max_gpa: 4,
                            required: true,
                          }"
                      >
                        <v-text-field
                            id="cumulativeGpa"
                            v-model="studentStatusItem.cumulativeGpa"
                            class="preservice-status-control"
                            dense
                            hide-details
                            name
                            outlined
                            step="0.01"
                            type="number"
                        ></v-text-field>
                        <span class="preservice-status-error text-gray-600 text-xs italic text-red-700">{{
                            errors[0]
                          }}</span>
                      </validation-provider>
                    </v-col>
                    <v-col class="preservice-status-add-cell" cols="12" md="2" sm="12">
                      <v-btn
                          class="preservice-status-add"
                          color="primary"
                          depressed
                          small
                          @click="addStudentStatus()"
                      >
                        <v-icon left>mdi-plus</v-icon>
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </div>

              <div class="w-full mb-6 md:mb-0">
                <template>
                  <v-data-table
                      :headers="headers"
                      :items="studentStatusItems"
                      class="elevation-1"
                  >
                    <template v-slot:top>
                      <v-dialog v-model="editDialog" max-width="500px">
                        <v-card class="preservice-dialog-card">
                          <v-card-title class="preservice-dialog-header preservice-dialog-header--compact">
                            <div class="preservice-dialog-header__icon">
                              <v-icon color="white">mdi-chart-timeline-variant</v-icon>
                            </div>
                            <div class="preservice-dialog-header__content">
                              <div class="preservice-dialog-header__title">Edit Student Status</div>
                              <div class="preservice-dialog-header__subtitle">
                                Update the student's year, status, and GPA.
                              </div>
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn
                                aria-label="Close student status dialog"
                                class="preservice-dialog-close"
                                icon
                                @click="cancelStudentStatus"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-card-title>

                          <v-card-text class="preservice-dialog-body">
                            <v-container>
                              <v-row>
                                <v-col cols="12" md="3" sm="6">
                                  <v-select
                                      v-model="studentStatusItem.yearOfEducation"
                                      :elevation="1"
                                      :items="YEAR_OF_EDUCATION"
                                      :loading="lookupLoading"
                                      class="pt-5"
                                      dense
                                      item-text="name"
                                      item-value="name"
                                      solo
                                  >
                                  </v-select>
                                </v-col>
                                <v-col cols="12" md="3" sm="6">
                                  <v-select
                                      v-model="studentStatusItem.studentStatus"
                                      :elevation="1"
                                      :items="STUDENT_STATUSES"
                                      :loading="lookupLoading"
                                      class="pt-5"
                                      dense
                                      item-text="name"
                                      item-value="name"
                                      solo
                                  ></v-select>
                                </v-col>
                                <v-col cols="12" md="3" sm="6">
                                  <v-text-field
                                      id="editGpa"
                                      v-model="studentStatusItem.gpa"
                                      class="pt-5"
                                      dense
                                      name
                                      solo
                                      step="0.01"
                                      type="number"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3" sm="6">
                                  <v-text-field
                                      id="editCumulativeGpa"
                                      v-model="studentStatusItem.cumulativeGpa"
                                      class="pt-5"
                                      dense
                                      name
                                      solo
                                      step="0.01"
                                      type="number"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>

                          <v-card-actions class="preservice-dialog-actions">
                            <v-spacer></v-spacer>
                            <v-btn
                                class="preservice-dialog-cancel"
                                text
                                @click="cancelStudentStatus"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                                class="preservice-dialog-submit"
                                depressed
                                @click="saveStudentStatus"
                            >
                              <v-icon left>mdi-content-save-outline</v-icon>
                              Save
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="deleteDialog" max-width="500px">
                        <v-card>
                          <v-card-title class="text-h5"
                          >Are you sure you want to delete this
                            item?
                          </v-card-title
                          >
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeDelete"
                            >Cancel
                            </v-btn
                            >
                            <v-btn
                                color="error darken-1"
                                text
                                @click="removeConfirmed"
                            >OK
                            </v-btn
                            >
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon class="mr-2" small @click="editStudentStatus(item)">
                        mdi-pencil
                      </v-icon>
                      <v-icon
                          small
                          style="color: #ff5252 !important;"
                          @click="removeStudentStatus(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </template>
              </div>
            </v-card>
          </ValidationObserver>
          <div class="flex flex-wrap my-6 mx-6 mb-6">
            <div class="preservice-form-actions">
              <v-btn
                  class="preservice-form-submit"
                  depressed
                  type="button"
                  :disabled="submitting"
                  @click="submit()"
              >
                <v-icon v-if="!submitting" left>
                  {{ formValues.editMode ? "mdi-account-check-outline" : "mdi-content-save-outline" }}
                </v-icon>
                {{
                  submitting
                    ? "Saving..."
                    : formValues.editMode
                      ? "Update"
                      : "Save"
                }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {max_value, min_value, regex, required,} from "vee-validate/dist/rules";
import ethiopic from "ethiopic-calendar";
import {
  formatBirthDateInput,
  getBirthDateValidationError,
  parseBirthDateInput,
} from "@/utils/birth-date-input";
import {formatFanId, isValidFanId, normalizeFanId} from "@/utils/fan-id";
import {
  getAssignedUniversityOption,
  getDisciplines,
  getEducationalPrograms,
  getEthnicities,
  getGenerationLevels,
  getLevelOfStudies,
  getStudentStatuses,
  getUniversities,
  getUniversityOwnership,
  isUniversityScopedPreserviceUser,
} from "@/utils/helper";
import {EducLevelEnum, YearOfEducEnum} from "@/utils/enums";
import preserviceBirthPlaceMixin from "@/mixins/preserviceBirthPlace";
import YearPickerField from "@/components/Graduates/shared/year-picker-field.vue";
import {normalizeStudentStatusGpaItems} from "@/utils/studentStatusGpa";
import {GraduateService} from "@/components/Graduates/graduates.service";
import {applySharedPreserviceIdentity} from "@/utils/preserviceSharedIdentity";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("fan_id", {
  validate: (value) => isValidFanId(value),
  message: "National ID (FAN) must contain exactly 16 digits",
});
extend("min_gpa", {
  ...min_value,
  message: "Invalid value. GPA must be greater than or equal to 0",
});
extend("max_gpa", {
  ...max_value,
  message: "Invalid value. GPA must be less than or equal to 4",
});
extend("generic_regex", {
  ...regex,
  message: "Invalid year value. Year must have 4 digits",
});
extend("regex", {
  ...regex,
  message: "Name should contain only letters",
});
extend("min_generic_value", {
  ...min_value,
  message: "Minimum year must be greater than 1950",
});
extend("max_generic_value", {
  ...max_value,
  message: "Maximum year must be less than or equal current year",
});
extend("min_proposed_value", {
  ...min_value,
  message: "Minimum year must be greater than or equal to proposed year",
});

export default {
  mixins: [preserviceBirthPlaceMixin],
  props: {
    graduates: Object,
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    YearPickerField,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        firstName: null,
        fatherName: null,
        grandFatherName: null,
        sex: null,
        dateOfBirth: null,
        idNo: null,
        educationProgramId: null,
        disciplineId: null,
        levelOfStudyId: null,
        entryYear: null,
        graduationYear: null,
        expectedYear: null,
        preServiceLevel: 'GenericEntry',
        nationality: 'Ethiopia',
        ethnicity: null,
        universityId: null,
        higherLearningInstitution: null,
        ownership: null,
        ownershipId: null,
        region: null,
        regionId: null,
        town: null,
        birthRegionId: null,
        birthZoneId: null,
        birthWoredaId: null,
        birthTownVillage: null,
        editMode: false,
      },
      subformValues: {
        yearOfEducation: null,
        studentStatus: null,
        gpa: null,
        cumulativeGpa: null,
      },
      menu: false,
      dstartMenu: false,
      today: new Date().toISOString().substr(0, 10),
      etDate: null,
      dateOfBirthInput: "",
      dateOfBirthError: "",
      idNo: null,
      currentYear: new Date().getFullYear(),
      etCurrentYear: null,
      OWNERSHIPS: [],
      GENERATION_LEVELS: [],
      UNIVERSITIES: [],
      universityLoading: false,
      educationalInstId: null,

      lookupLoading: false,
      activePicker: null,
      maxBirthDate: null,
      STUDENT_STATUSES: [],
      originalData: {
        yearOfEducation: null,
        studentStatus: null,
        gpa: null,
        cumulativeGpa: null,
      },
      defaultItem: {
        yearOfEducation: null,
        studentStatus: null,
        gpa: null,
        cumulativeGpa: null,
      },
      studentStatusItems: [],
      studentStatusItem: {
        yearOfEducation: null,
        studentStatus: null,
        gpa: null,
        cumulativeGpa: null,
      },
      editIndex: -1,
      editedIndex: -1,
      dataTableLight: true,
      YEAR_OF_EDUCATION: [],
      EDUC_LEVEL: [],
      headers: [
        {
          text: "Year of Education",
          align: "start",
          value: "yearOfEducation",
        },
        {text: "Student Status", value: "studentStatus"},
        {text: "GPA", value: "gpa"},
        {text: "Cumulative GPA", value: "cumulativeGpa"},
        {text: "Actions", value: "actions"},
      ],
      editDialog: false,
      deleteDialog: false,
      LEVEL_OF_STUDIES: [],
      DISCIPLINES: [],
      EDUCATIONAL_PROGRAMS: [],
      ETHNICITIES: [],


      programValue: null,
      allDisciplines: [],
      disciplineValue: null,
      entryYearValue: null,
      proposedYearValue: null,
      selectedUniversity: null,
      identityLookupLoading: false,
      lastIdentityLookupId: null,
    };
  },
  watch: {
    menu(val) {
      val &&
      this.$nextTick(() => (this.$refs.dateOfBirth.activePicker = "YEAR"));
    },
    options: {
      handler() {
      },
      deep: true,
    },
    "formValues.idNo": function (value) {
      const formattedValue = formatFanId(value);
      if (formattedValue !== value) {
        this.formValues.idNo = formattedValue;
        return;
      }

      if (normalizeFanId(formattedValue) !== this.lastIdentityLookupId) {
        this.lastIdentityLookupId = null;
      }
    },
    programValue: function (val) {
      this.programValue = val == '' ? null : val;
      this.fetchOnFilters();
    },
    disciplineValue: function () {
      this.syncProposedYear();
    },
    entryYearValue: function (val) {
      this.entryYearValue = val == '' ? null : val;
      this.fetchOnFilters();
    },
  },
  computed: {
    isUniversityScopedUser() {
      return isUniversityScopedPreserviceUser();
    },
  },
  async created() {
    await this.initateLookups();
    this.etDate = this.convertGE(this.today);
    this.maxBirthDate = this.currentYear - 17 + "-12-31";
    this.etCurrentYear = this.convertYearGE(this.currentYear);
    if (this.graduates != null) {
      this.formValues = {
        ...this.formValues,
        ...this.graduates,
      };
      const existingStudentStatuses = Array.isArray(this.graduates.pre_student_statuses)
          ? this.graduates.pre_student_statuses.map(this.normalizeStudentStatusItem)
          : Array.isArray(this.graduates.preStudentStatuses)
              ? this.graduates.preStudentStatuses.map(this.normalizeStudentStatusItem)
              : [];
      this.studentStatusItems = this.calculateStudentStatusItems(existingStudentStatuses);
      this.formValues.editMode = true;
    }
    this.dateOfBirthInput = formatBirthDateInput(this.formValues.dateOfBirth);
    this.formValues.idNo = formatFanId(this.formValues.idNo);
    this.syncEditSelections();
    await this.loadBirthPlaceLookups();

    await this.initializeUniversities();
    this.syncSelectedUniversity();
  },
  methods: {
    async initializeUniversities() {
      this.universityLoading = true;

      try {
        const univResp = await getUniversities();
        this.UNIVERSITIES =
          univResp.rows && univResp.rows.length > 0
            ? univResp.rows.filter((data) => data.isActive === true)
            : [];

        if (this.isUniversityScopedUser) {
          const assignedUniversity = getAssignedUniversityOption();
          if (assignedUniversity) {
            this.UNIVERSITIES = this.UNIVERSITIES.filter(
              (item) => Number(item.id) === Number(assignedUniversity.id)
            );
            if (!this.UNIVERSITIES.length) {
              this.UNIVERSITIES = [assignedUniversity];
            }
            this.selectedUniversity = this.UNIVERSITIES[0];
            this.applyUniversitySelection(this.selectedUniversity);
          }
        }
      } finally {
        this.universityLoading = false;
      }
    },
    normalizeStudentStatusItem(item = {}) {
      return {
        ...item,
        gpa: item.gpa ?? null,
        cumulativeGpa: item.cumulativeGpa ?? null,
      };
    },
    calculateStudentStatusItems(items = []) {
      return normalizeStudentStatusGpaItems(
          items,
          this.YEAR_OF_EDUCATION
      );
    },
    parseValidatedGpa(value) {
      if (value === "" || value == null) {
        return {valid: false, message: "This field is required"};
      }

      const parsedValue = Number(value);
      if (!Number.isFinite(parsedValue)) {
        return {valid: false, message: "This field is required"};
      }

      if (parsedValue < 0) {
        return {valid: false, message: "Invalid value. GPA must be greater than or equal to 0"};
      }

      if (parsedValue > 4) {
        return {valid: false, message: "Invalid value. GPA must be less than or equal to 4"};
      }

      return {valid: true, value: parsedValue};
    },
    validateStudentStatusGpas(statusItem) {
      const gpaValidation = this.parseValidatedGpa(statusItem?.gpa);
      if (!gpaValidation.valid) {
        this.$toast.error(`GPA: ${gpaValidation.message}`);
        return false;
      }
      const cumulativeGpaValidation = this.parseValidatedGpa(
          statusItem?.cumulativeGpa
      );
      if (!cumulativeGpaValidation.valid) {
        this.$toast.error(
            `Cumulative GPA: ${cumulativeGpaValidation.message}`
        );
        return false;
      }

      statusItem.gpa = gpaValidation.value;
      statusItem.cumulativeGpa = cumulativeGpaValidation.value;
      return true;
    },
    syncSelectedUniversity() {
      if (!Array.isArray(this.UNIVERSITIES)) {
        return;
      }

      if (this.isUniversityScopedUser) {
        const assignedUniversity = getAssignedUniversityOption();
        if (assignedUniversity) {
          this.selectedUniversity =
            this.UNIVERSITIES.find(
              (item) => Number(item?.id) === Number(assignedUniversity.id)
            ) || assignedUniversity;
          this.applyUniversitySelection(this.selectedUniversity);
        }
        return;
      }

      const currentInstitution = (this.formValues.higherLearningInstitution || "").trim().toLowerCase();
      if (!currentInstitution) {
        this.selectedUniversity = null;
        return;
      }

      this.selectedUniversity = this.UNIVERSITIES.find(
          (item) => (item?.name || "").trim().toLowerCase() === currentInstitution
      ) || null;

      if (!this.selectedUniversity) {
        this.selectedUniversity = {
          id: this.formValues.universityId,
          name: this.formValues.higherLearningInstitution,
          ownership: {name: this.formValues.ownership},
          ownershipId: this.formValues.ownershipId,
          region: {name: this.formValues.region},
          regionId: this.formValues.regionId,
          town: this.formValues.town,
        };
      }

      if (this.selectedUniversity) {
        this.applyUniversitySelection(this.selectedUniversity);
      }
    },
    applyUniversitySelection(university) {
      if (!university) {
        this.formValues.universityId = null;
        this.formValues.higherLearningInstitution = null;
        this.formValues.ownership = null;
        this.formValues.ownershipId = null;
        this.formValues.region = null;
        this.formValues.regionId = null;
        this.formValues.town = null;
        return;
      }

      this.formValues.universityId = university.id || null;
      this.formValues.higherLearningInstitution = university.name || null;
      this.formValues.ownership = university.ownership?.name || null;
      this.formValues.ownershipId = university.ownershipId || university.ownership?.id || null;
      this.formValues.region = university.region?.name || null;
      this.formValues.regionId = university.regionId || university.region?.id || null;
      this.formValues.town = university.town || null;
    },
    onUniversityChanged(university) {
      this.applyUniversitySelection(university);
    },
    async loadExistingStudentIdentity() {
      if (this.formValues.editMode || this.identityLookupLoading) {
        return;
      }

      const normalizedId = normalizeFanId(this.formValues.idNo);
      if (!isValidFanId(normalizedId) || normalizedId === this.lastIdentityLookupId) {
        return;
      }

      this.identityLookupLoading = true;

      try {
        const response = await GraduateService.findPreServiceStudentIdentity(normalizedId);
        const identityRecord = response?.data?.data || null;
        this.lastIdentityLookupId = normalizedId;

        if (!identityRecord) {
          return;
        }

        this.formValues = applySharedPreserviceIdentity(this.formValues, identityRecord);
        this.dateOfBirthInput = formatBirthDateInput(this.formValues.dateOfBirth);
        await this.syncBirthPlaceLookups();
        const enrollmentCount = identityRecord.existingEnrollments?.length || 0;
        this.$toast.info(
          enrollmentCount
            ? `Student identity loaded. ${enrollmentCount} existing enrolment(s) found; a different department is allowed.`
            : "Student information loaded from the existing national ID.",
        );
      } catch (error) {
        this.$toast.error("Unable to load student information for the selected national ID.");
      } finally {
        this.identityLookupLoading = false;
      }
    },
    syncProposedYear() {
      const currentEntryYear = this.entryYearValue ?? this.formValues.entryYear;
      const selectedDiscipline = this.disciplineValue || this.allDisciplines.find(
          (item) => item?.id == this.formValues.disciplineId
      );

      if (currentEntryYear && selectedDiscipline?.disciplineYear != null) {
        this.proposedYearValue = +currentEntryYear + +selectedDiscipline.disciplineYear;
        return;
      }

      this.proposedYearValue = this.formValues.expectedYear ?? null;
    },
    syncEditSelections() {
      const selectedProgramId = this.formValues.educationProgramId;
      this.programValue = this.EDUCATIONAL_PROGRAMS.find(
          (item) => item?.id == selectedProgramId
      ) || null;
      this.entryYearValue = this.formValues.entryYear ?? null;
      this.DISCIPLINES = this.allDisciplines.filter(
          (item) => item?.educationProgramId == selectedProgramId
      );
      this.disciplineValue = this.DISCIPLINES.find(
          (item) => item?.id == this.formValues.disciplineId
      ) || this.allDisciplines.find(
          (item) => item?.id == this.formValues.disciplineId
      ) || null;
      this.applyDefaultLevelOfStudy();
      this.syncProposedYear();
    },
    async fetchOnFilters() {
      const selectedProgramId = this.programValue?.id || this.formValues.educationProgramId;
      this.DISCIPLINES = this.allDisciplines.filter(x => x.educationProgramId == selectedProgramId);
      this.syncProposedYear();
    },
    async initateLookups() {
      this.lookupLoading = true;
      this.OWNERSHIPS = await getUniversityOwnership();
      this.GENERATION_LEVELS = await getGenerationLevels();
      this.STUDENT_STATUSES = await getStudentStatuses();
      this.YEAR_OF_EDUCATION = [{name: "Not Applicable", code: "NA"}].concat(await YearOfEducEnum);

      this.EDUC_LEVEL = await EducLevelEnum;
      this.ETHNICITIES = await getEthnicities();
      this.ETHNICITIES = this.ETHNICITIES?.rows || [];
      this.LEVEL_OF_STUDIES = await getLevelOfStudies();
      this.LEVEL_OF_STUDIES = this.LEVEL_OF_STUDIES.rows.filter(x => x.level_type == 'Generic Entry');
      this.applyDefaultLevelOfStudy();
      this.allDisciplines = await getDisciplines({
        scope: "standard",
        levelType: "Generic Entry",
      });
      this.allDisciplines = this.allDisciplines.rows;
      this.EDUCATIONAL_PROGRAMS = await getEducationalPrograms({scope: "standard"})
      this.EDUCATIONAL_PROGRAMS = this.EDUCATIONAL_PROGRAMS.rows
      this.lookupLoading = false;
    },
    getDefaultLevelOfStudy() {
      return this.LEVEL_OF_STUDIES.find(
          (item) => (item?.name || "").trim().toLowerCase() === "degree"
      ) || null;
    },
    applyDefaultLevelOfStudy() {
      if (this.formValues.levelOfStudyId) {
        return;
      }

      const defaultLevel = this.getDefaultLevelOfStudy();
      if (defaultLevel?.id != null) {
        this.formValues.levelOfStudyId = defaultLevel.id;
      }
    },
    validateDateOfBirth() {
      this.dateOfBirthError = getBirthDateValidationError(
          this.dateOfBirthInput,
          this.maxBirthDate
      );

      if (this.dateOfBirthError) {
        this.formValues.dateOfBirth = null;
        return false;
      }

      const parsedDate = parseBirthDateInput(this.dateOfBirthInput);
      this.formValues.dateOfBirth = parsedDate.isoDate;
      return true;
    },
    onDateOfBirthInput(value) {
      this.dateOfBirthInput = value;

      const parsedDate = parseBirthDateInput(value);
      if (parsedDate.isValid && parsedDate.isoDate && parsedDate.isoDate <= this.maxBirthDate) {
        this.dateOfBirthError = "";
        this.formValues.dateOfBirth = parsedDate.isoDate;
        return;
      }

      this.validateDateOfBirth();
    },
    onDateOfBirthPicked(value) {
      this.formValues.dateOfBirth = value;
      this.dateOfBirthInput = formatBirthDateInput(value);
      this.dateOfBirthError = "";
      this.menu = false;
    },
    convertGE(val) {
      if (!val) return val;
      const [year, month, day] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
        return etDate.year.toString().padStart(4, "0");
      } else {
        let etDate = ethiopic.ge(year, month || 1, day || 1);
        return (
            etDate.year.toString().padStart(4, "0") +
            "-" +
            etDate.month.toString().padStart(2, "0") +
            "-" +
            etDate.day.toString().padStart(2, "0")
        );
      }
    },
    convertYearGE(val) {
      if (!val) return val;
      const year = val;
      const month = null;
      const day = null;
      let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
      return etDate.year.toString().padStart(4, "0");
    },
    async addStudentStatus() {
      if (!(await this.$refs.subForm.validate())) return;
      const draftItem = {...this.studentStatusItem};
      if (!this.validateStudentStatusGpas(draftItem)) {
        return;
      }
      const isStatusExists = this.studentStatusItems.some(
          (item) => item.yearOfEducation === draftItem.yearOfEducation
      );
      if (isStatusExists) {
        this.$toast.error("Student grade information for this year of education already exists.");
        return;
      }
      this.studentStatusItems = this.calculateStudentStatusItems([
        ...this.studentStatusItems,
        draftItem,
      ]);
      this.editIndex = this.studentStatusItems.length;
      this.studentStatusItem = {
        yearOfEducation: null,
        studentStatus: null,
        gpa: null,
        cumulativeGpa: null,
      };
    },
    editStudentStatus(item) {
      this.editedIndex = this.studentStatusItems.indexOf(item);
      this.studentStatusItem = this.normalizeStudentStatusItem(item);
      this.editDialog = true;
    },
    cancelStudentStatus() {
      this.editDialog = false;
      this.$nextTick(() => {
        this.studentStatusItem = Object.assign({}, this.originalData);
        this.editedIndex = -1;
      });
    },
    removeStudentStatus(item) {
      this.editedIndex = this.studentStatusItems.indexOf(item);
      this.studentStatusItem = Object.assign({}, item);
      this.deleteDialog = true;
    },
    removeConfirmed() {
      const nextItems = [...this.studentStatusItems];
      nextItems.splice(this.editedIndex, 1);
      this.studentStatusItems = this.calculateStudentStatusItems(nextItems);
      this.closeDelete();
    },
    saveStudentStatus() {
      const draftItem = {...this.studentStatusItem};
      if (!this.validateStudentStatusGpas(draftItem, this.editedIndex)) {
        return;
      }

      const duplicateStatusIndex = this.studentStatusItems.findIndex(
          (item, index) =>
              item.yearOfEducation === draftItem.yearOfEducation &&
              index !== this.editedIndex
      );
      if (duplicateStatusIndex !== -1) {
        this.$toast.error("Student grade information for this year of education already exists.");
        return;
      }

      if (this.editedIndex > -1) {
        const nextItems = [...this.studentStatusItems];
        nextItems.splice(this.editedIndex, 1, draftItem);
        this.studentStatusItems = this.calculateStudentStatusItems(nextItems);
      } else {
        this.studentStatusItems = this.calculateStudentStatusItems([
          ...this.studentStatusItems,
          draftItem,
        ]);
      }
      this.closeDialog();
    },
    closeDialog() {
      this.editDialog = false;
      this.$nextTick(() => {
        this.studentStatusItem = Object.assign({}, this.originalData);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.deleteDialog = false;
      this.$nextTick(() => {
        this.studentStatusItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async submit() {
      const selectedProgram = this.programValue || this.EDUCATIONAL_PROGRAMS.find(
          (item) => item?.id == this.formValues.educationProgramId
      );
      const selectedDiscipline = this.disciplineValue || this.allDisciplines.find(
          (item) => item?.id == this.formValues.disciplineId
      );
      const selectedUniversity = this.selectedUniversity || this.UNIVERSITIES.find(
          (item) => item?.id == this.formValues.universityId
      ) || null;
      this.formValues.studentStatuses = this.studentStatusItems;
      this.formValues.educationProgramId = selectedProgram?.id || null;
      this.formValues.disciplineId = selectedDiscipline?.id || null;
      this.formValues.entryYear = this.entryYearValue ?? this.formValues.entryYear;
      this.formValues.expectedYear = this.proposedYearValue ?? this.formValues.expectedYear;
      this.formValues.universityId = selectedUniversity?.id || this.formValues.universityId || null;

      if (!this.validateDateOfBirth()) return;
      if (!(await this.$refs.mainForm.validate())) return;
      if (this.studentStatusItems.length === 0) {
        this.$toast.error("Add at least one student grade entry before saving.");
        return;
      }
      this.formValues.idNo = normalizeFanId(this.formValues.idNo);
      this.$emit("registerOrUpdateGenericEntries", this.formValues);
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
